import { useContext, useState } from "react"
import styles from "./index.module.scss"
import { GenerateContext } from "../../../hooks/GenerateContext"
import { IMAGE_TYPE, VIDEO_ORIENTATION } from "@utils/CONST"
import Iconfont from '@utils/Iconfont';
import { Popover, Divider, Input, message, Collapse, Button } from "antd"
import { RightOutlined, LeftOutlined, UpOutlined, DownOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import GenerateMode from '../GenerateMode'
import API from '@api/api';
import eventBus from '@utils/eventBus';

const { TextArea } = Input;


const ImgToVideoParams = (props) => {
    const {
        prompt, setPrompt,
        duration, setDuration,
        orientation, setOrientation,
    } = useContext(GenerateContext)

    const [promptCollapseOpen, setPromptCollapseOpen] = useState(true)
    const [lastFavorPrompt, setLastFavorPrompt] = useState("")

    const normalizedPrompt = (prompt ?? "").trim()
    const isFavorCurrent = !!normalizedPrompt && normalizedPrompt === lastFavorPrompt
    const canFavorPrompt = !!normalizedPrompt && normalizedPrompt !== lastFavorPrompt

    const {
        drawerOpen,
        onDrawerOpen,
        onDrawerClose,
        imageType
    } = props

    const PopoverContent = (
        <div className={styles.ImgToVideoContent}>
            <p>基础提示词由 <span style={{ color: '#006EFF' }}>主体</span>+<span style={{ color: '#FF8D29' }}>运动</span>，<span style={{ color: '#34C759' }}>背景</span>+<span style={{ color: '#006EFF' }}>运动</span> ... 组成</p>
            <Divider />
            <p>主体：画面中占据核心视觉焦点的人物、动物、商品等核心对象；</p>
            <p>背景：画面内除核心主体外，用于衬托主体的所有环境元素；</p>
            <p>运动：核心主体与背景需达成的预设运动轨迹及动态呈现效果。</p>
            <p>精简和准确的描述“主体+运动”模型会更容易理解指令</p>
            <p>比如：<span style={{ color: '#006EFF' }}>画面中的女性</span><span style={{ color: '#FF8D29' }}>摘下墨镜</span>，<span style={{ color: '#34C759' }}>街上</span><span style={{ color: '#FF8D29' }}>行人经过</span></p>
        </div>
    )

    const PopoverContentOrientation = (
        <div className={styles.PopoverContentOrientation}>
            <div className={styles.OrientationItem}>
                <p>与模特图一致</p>
                <div className={styles.OrientationItemBg}></div>
                <p>动作与视频一致，朝向与图片中人物一致，最长支持10s生成时长</p>
            </div>
            <div className={styles.OrientationItem}>
                <p>与参考视频一致</p>
                <div className={styles.OrientationItemBg2}></div>
                <p>完全参照动作视频生成。最长支持30s生成时长</p>
            </div>
        </div>
    )

    const handleAddPrompt = async () => {
        if (!canFavorPrompt) return
        const res2 = await API.saveCustomMaterialv2({
            func: IMAGE_TYPE.IMAGE_TO_VIDEO,
            type: 'image2VideoPrompt',
            image: normalizedPrompt,
            attr: {
                title: `未命名`,
            }
        })
        if (res2?.code != 0) throw new Error(res2?.message)
        setLastFavorPrompt(normalizedPrompt)
        eventBus.emit('updateImgToVideoPrompt')
        message.success('收藏成功')
    }

    const handleClear = () => {
        setPrompt('')
    }

    return (
        <div className={styles.ImgToVideoParams}>
            {
                imageType == IMAGE_TYPE.IMAGE_TO_VIDEO ? <>
                    <div className={styles.Title}>
                        <div>视频画面描述
                            <Popover content={PopoverContent} placement="right">
                                <Iconfont className={styles.Icon} type="icon-qa2" />
                            </Popover>
                        </div>

                    </div>
                    <div className={styles.PromptWrap}>
                        <TextArea
                            className={styles.PromptInput}
                            value={prompt}
                            maxLength={2500}
                            onChange={e => setPrompt(e.target.value)}
                            placeholder="请描述参考图主体的变化情况
提示词建议主体+主体运动，背景+背景运动，例如：“把图中的人物姿势改为一只手自然下垂，另一只手叉腰“"
                            autoSize={{ minRows: 14, maxRows: 14 }}
                        />
                        <div className={styles.TitleActions}>
                            <Button type="text" size="small" className={`${styles.TitleActionBtn} ${styles.FavorPrompt} ${canFavorPrompt || isFavorCurrent ? styles.active : ''}`} onClick={canFavorPrompt ? handleAddPrompt : undefined}>
                                <Iconfont type={isFavorCurrent ? "icon-StarFilled" : "icon-StarOutlined"} style={isFavorCurrent ? { color: '#FFBC3F' } : undefined} />
                            </Button>
                            <Button type="text" size="small" className={`${styles.TitleActionBtn} ${styles.DeleteActionBtn}`} onClick={handleClear}>
                                <Iconfont type="icon-DeleteOutlined" />
                            </Button>
                            <Button type="text" size="small" className={`${styles.TitleActionBtn} ${styles.TitleTemplateBtn}`}
                                onClick={drawerOpen ? onDrawerClose : onDrawerOpen}>
                                <Iconfont type="icon-tutorialOutlined" />
                                <span>描述模版</span>
                                {/* {drawerOpen ? <LeftOutlined /> : <RightOutlined />} */}
                            </Button>
                        </div>
                    </div>
                    <p className={styles.Title} style={{ marginTop: 24 }}>视频生成时长</p>
                    <div className={styles.TimeBtn} style={{ marginBottom: 24 }}>
                        <div
                            className={`${styles.Btn} ${duration === 5 ? styles.BtnActive : ''}`}
                            onClick={() => setDuration(5)}
                        >5 秒</div>
                        <div
                            className={`${styles.Btn} ${duration === 10 ? styles.BtnActive : ''}`}
                            onClick={() => setDuration(10)}>10 秒</div>
                    </div>
                </> : <>
                    <div className={styles.Title}>
                        <div>人物朝向选择
                            <Popover content={PopoverContentOrientation} placement="right">
                                {/* <Iconfont className={styles.Icon} style={{ color: '#96A2B1' }} type="icon-qa2" /> */}
                                <QuestionCircleOutlined style={{ marginLeft: 8, cursor: 'pointer' }} />
                            </Popover>
                        </div>
                    </div>
                    <div className={styles.TimeBtn} >
                        <div
                            className={`${styles.Btn} ${orientation === VIDEO_ORIENTATION.REF ? styles.BtnActive : ''}`}
                            onClick={() => setOrientation(VIDEO_ORIENTATION.REF)}
                        >与参考视频一致</div>
                        <div
                            className={`${styles.Btn} ${orientation === VIDEO_ORIENTATION.SRC ? styles.BtnActive : ''}`}
                            onClick={() => setOrientation(VIDEO_ORIENTATION.SRC)}>与模特图一致</div>
                    </div>
                    <Collapse
                        activeKey={promptCollapseOpen ? ['1'] : []}
                        onChange={(keys) => {
                            const nextOpen = Array.isArray(keys) ? keys.includes('1') : keys === '1'
                            setPromptCollapseOpen(nextOpen)
                        }}
                        ghost
                        items={[{
                            key: '1',
                            showArrow: false,
                            label: (
                                <div className={styles.Title} style={{ marginTop: 24 }}>
                                    <div>
                                        提示词输入<span style={{ color: '#96A2B1' }}>（非必填）</span>
                                    </div>
                                    {promptCollapseOpen ? <UpOutlined /> : <DownOutlined />}
                                </div>
                            ),
                            children: <div className={styles.PromptWrap} style={{ marginBottom: 24 }}>
                                <TextArea
                                    className={styles.PromptInput}
                                    value={prompt}
                                    maxLength={800}
                                    onChange={e => setPrompt(e.target.value)}
                                    placeholder="请描述参考图主体的变化情况
例如：“把图中的人物姿势改为一只手自然下垂，另一只手叉腰“"
                                    autoSize={{ minRows: 6, maxRows: 6 }}
                                />
                            </div>,
                        }]}
                    />

                </>
            }
            <GenerateMode imageType={imageType} />
        </div>
    )
}

export default ImgToVideoParams
